var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShortAnswer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#f2f0ff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.912 11a1 1 0 00-.863.578l-7.955 17a1 1 0 001.812.846l2.828-6.043c.015 0 .028.008.043.008H19a1 1 0 100-2h-3.334l3.26-6.967 1.964 4.48a1 1 0 001.832-.804l-2.851-6.5a1 1 0 00-.96-.598zm6.898 9c-2.55 0-3.876 1.485-4.359 2.387a1 1 0 101.764.941c.3-.562.724-1.328 2.595-1.328.898 0 1.377.277 1.69.604.312.326.443.76.443 1.04v1.032c-1.196-.205-2.598-.35-3.816-.184-.734.1-1.508.327-2.113.82-.65.53-1.014 1.294-1.014 2.235 0 1.06.189 2.014.846 2.67.661.66 1.564.783 2.365.783h4.42c.026 0 .048-.014.074-.016A1 1 0 0029.943 30v-6.356c0-.816-.308-1.703-1-2.425-.691-.722-1.777-1.22-3.133-1.22zm-.515 6.418c.844 0 1.78.126 2.648.29V29h-3.732c-.673 0-.876-.122-.951-.197-.08-.08-.26-.353-.26-1.256 0-.376.122-.557.28-.686.202-.165.56-.312 1.118-.388.28-.039.581-.055.897-.055z"
  })));
}

export default SvgShortAnswer;